import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import './index.scss';

interface IRealizationListProps {
  title: string;
  list: { refNumber: string; sum: string; link: string }[];
}

const RealizationList: FC<IRealizationListProps> = ({ title, list }) => (
  <div className="realization-list">
    <h3 className="realization-list__title">{title}</h3>
    <div className="realization-list__container">
      <div className="realization-list__header">
        <div className="realization-list__header__item">Реализации</div>
        <div className="realization-list__header__item">Цена</div>
      </div>
      {list.map((item) => (
        <div className="realization-list__item">
          <div className="realization-list__item__title">
            <Link className="link link--no-border" to={item.link}>
              {item.refNumber}
            </Link>
          </div>
          <div className="realization-list__item__price">{item.sum}</div>
        </div>
      ))}
    </div>
  </div>
);

export default RealizationList;
